import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from "recharts";

const ChartComponent = ({ title, data, chartType, nameKey }) => {
  const colors = ["#8884d8", "#82ca9d", "#ffc658"]; // Define your colors for the charts
  const blueColorVariants = [
    "#6baed6",
    "#4292c6",
    "#2171b5",
    "#08519c",
    "#08306b"
  ];
  // Render a PieChart
  const renderPieChart = () => (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          outerRadius={95}
          fill="#8884d8"
          dataKey="count"
          nameKey={nameKey}
          labelLine={false}
          label={({
            cx,
            cy,
            midAngle,
            innerRadius,
            outerRadius,
            value,
            name,
            percent
          }) => {
            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
            const RADIAN = Math.PI / 180;
            const x = cx + radius * Math.cos(-midAngle * RADIAN);
            const y = cy + radius * Math.sin(-midAngle * RADIAN);
            return (
              <text
                x={x}
                y={y}
                fill="white"
                textAnchor="middle"
                dominantBaseline="central"
              >
                {`${name} (${(percent * 100).toFixed(0)}%)`}
              </text>
            );
          }}
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={blueColorVariants[index % blueColorVariants.length]}
            />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );

  // Render a BarChart
  const renderBarChart = () => (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart data={data}>
        <XAxis dataKey={nameKey} />
        <YAxis />
        <Tooltip />
        <Bar
          dataKey="count"
          fill="#00338d"
          barSize={20}
          radius={[10, 10, 10, 10]}
        />
      </BarChart>
    </ResponsiveContainer>
  );

  // Determine which chart to render based on the `chartType` prop
  const renderChart = () => {
    switch (chartType) {
      case "Pie":
        return renderPieChart();
      case "Bar":
        return renderBarChart();
      default:
        return null;
    }
  };

  return (
    <div className="chart-container">
      <h3
        style={{
          color: "#2B3F6C",
          textAlign: "center",
          fontSize: 20,
          paddingLeft: "15%",
          marginBottom: "20px"
        }}
      >
        {title}
      </h3>
      {data ? renderChart() : <p>No data available</p>}
    </div>
  );
};

export default ChartComponent;
